import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const sixtyGreyDescriptionParagraphs = [
  "Plongeant dans l'énergie vibrante des années 60, cette collection capture l'essence rétro avec des teintes douces et des motifs audacieux. Chaque création revisite les classiques vintage tout en leur apportant une touche contemporaine.",
  "Les silhouettes emblématiques des sixties se mêlent à des coupes modernes, incarnant une élégance décontractée. Les textures légères et les motifs graphiques insufflent une fraîcheur qui célèbre l'esprit de liberté de cette époque.",
  "Cette série illustre une parfaite harmonie entre nostalgie et modernité, où chaque pièce invite à revivre une époque audacieuse tout en restant ancrée dans le luxe d'aujourd'hui.",
];

export const sixtyGreyCollection: CollectionData = {
  id: "2023-60s-grey",
  title: "Collection 60's Grey",
  descriptionParagraphs: sixtyGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-19"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-20"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-21"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-22"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-23"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-24"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-25"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-26"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-27"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-28"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-29"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-30"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-31"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-32"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-33"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-34"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-35"),
    getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-36"),
  ],
  date: "04/23",
  bannerImage: getCollectionImageUrl("2023-60s-grey", "ALEXANDRA-GREY-60S-GREY-19"),
};
